module.exports = __webpack_public_path__ + "8db4b09b7e777b6744b3b6403d6370ea.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/icon-twitter.svg
// module id = 8
// module chunks = 0